import { render } from "./TransactionsDashboard.vue?vue&type=template&id=4b3ecbe9&scoped=true"
import script from "./TransactionsDashboard.vue?vue&type=script&lang=js"
export * from "./TransactionsDashboard.vue?vue&type=script&lang=js"

import "./TransactionsDashboard.vue?vue&type=style&index=0&id=4b3ecbe9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3ecbe9"]])

export default __exports__